import React, { useMemo } from 'react';
import { ContentPanel } from '../../../../../../components/ContentPanel';
import { SidebarPanelTitle } from '../../../../../../components/content-side-bar/SidebarPanelTitle';
import { SidebarButton } from '@components/content-side-bar';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PortalSessionListItem } from '../PortalSessionListItem';
import {
  filterUpcomingPortalSessions,
  UPCOMING_SESSIONS_SIDEBAR_LIMIT,
} from '../../sessionHelpers';
import { ISessionsSidebarPanel } from './interfaces';

export const SessionsSidebarPanel: React.FC<ISessionsSidebarPanel> = ({
  sessions,
  isLoading = false,
  onShowMore,
  onCompletedSessionClick,
}): JSX.Element | null => {
  const { t } = useTranslation();

  const upcomingSessions = useMemo(
    () => filterUpcomingPortalSessions(sessions),
    [sessions]
  );

  const visibleSessions = useMemo(
    () => upcomingSessions.slice(0, UPCOMING_SESSIONS_SIDEBAR_LIMIT),
    [upcomingSessions]
  );

  const hasMoreUpcoming =
    upcomingSessions.length > UPCOMING_SESSIONS_SIDEBAR_LIMIT;

  if (isLoading) {
    return null;
  }

  if (upcomingSessions.length === 0) {
    return null;
  }

  return (
    <ContentPanel borderRadius="none">
      <SidebarPanelTitle
        title={t('competitions:portal.details.sessionsPanel.title')}
        sx={{ mb: '12px' }}
      />
      <Stack sx={{ gap: 1 }}>
        {visibleSessions.map((session) => (
          <PortalSessionListItem
            key={session.id}
            session={session}
            onCompletedSessionClick={onCompletedSessionClick}
          />
        ))}
      </Stack>
      {hasMoreUpcoming && (
        <SidebarButton onClick={onShowMore} sx={{ mt: 1.5 }}>
          {t('competitions:portal.details.sessionsPanel.showMore')}
        </SidebarButton>
      )}
    </ContentPanel>
  );
};
